// extracted by mini-css-extract-plugin
export default {"save-view-dialog":"SaveViewDialog_save-view-dialog__MzEcg","save-view-dialog-content":"SaveViewDialog_save-view-dialog-content__Ne9+B"};